var req = require("!!/Users/dw/Exploros/front-end/webpack/loaders/pug-template-loader.js!/Users/dw/Exploros/front-end/components/helpVideos/videoLink.jade");
module.exports = (req['default'] || req).apply(req, [])